import { render, staticRenderFns } from "./CopyToGalleryModal.vue?vue&type=template&id=35d9c064&scoped=true&"
import script from "./CopyToGalleryModal.vue?vue&type=script&lang=js&"
export * from "./CopyToGalleryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d9c064",
  null
  
)

export default component.exports